export default {
  filters: {
    moneyFormatter: function (value, curr)
    {
      if (curr == null)
      {
        curr = 'EUR'
      }
      if (value === '' || value === null || typeof value === 'undefined')
      {
        return value
      }
      const parsed = parseFloat(value)
      if (isNaN(parsed))
      {
        console.error('failed to convert input to number:', value)
        return 'NaN'
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: curr,
        minimumFractionDigits: 2
      })
      return formatter.format(parsed)
    },
    moneyFormatter00: function (value)
    {
      if (value === '' || value === null || typeof value === 'undefined')
      {
        return value
      }
      const parsed = parseFloat(value)
      if (isNaN(parsed))
      {
        console.error('failed to convert input to number:', value)
        return 'NaN'
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
      return formatter.format(parsed)
    },
    moneyFormatterWithCurrency: function (value, currency)
    {
      if (value === '' || value === null || typeof value === 'undefined')
      {
        return value
      }
      const parsed = parseFloat(value)
      if (isNaN(parsed))
      {
        console.error('failed to convert input to number:', value)
        return 'NaN'
      }
      let decimalDigits = 2
      if (parsed > 999999)
      {
        decimalDigits = 0
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: decimalDigits,
        spaceBetweenAmountAndSymbol: true
      })
      return formatter.format(parsed)
    },
    moneyFormatterWithoutCents: function (value, curr)
    {
      if (curr == null)
      {
        curr = 'EUR'
      }
      if (value === '' || value === null || typeof value === 'undefined')
      {
        return value
      }
      const parsed = parseFloat(value)
      if (isNaN(parsed))
      {
        console.error('failed to convert input to number:', value)
        return 'NaN'
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: curr,
        minimumFractionDigits: 0
      })
      return formatter.format(parsed)
    }
  },
  methods: {
    showAsPercentages(value, decimalDigits)
    {
      if (decimalDigits > 0)
      {
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: decimalDigits,
          maximumFractionDigits: decimalDigits
        })
        return (formatter.format(parseFloat(value)) + '%')
      }
      else
      {
        return value ? (parseFloat(value) + '%') : ''
      }
    }
  }
}
